var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprove({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Approve",
    transform: "translate(-630 -598)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(630 598)",
    fill: "#52D57D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_7",
    "data-name": "Union 7",
    d: "M8843.679-14919.605l-2.353-2.281a1.056,1.056,0,0,1-.326-.75,1.055,1.055,0,0,1,.3-.757,1.068,1.068,0,0,1,.768-.325,1.067,1.067,0,0,1,.742.3l1.614,1.566,5.072-4.855a1.075,1.075,0,0,1,.738-.3,1.064,1.064,0,0,1,.771.33,1.06,1.06,0,0,1,.3.761,1.069,1.069,0,0,1-.329.749l-5.818,5.563a1.055,1.055,0,0,1-.734.3A1.053,1.053,0,0,1,8843.679-14919.605Z",
    transform: "translate(-8206.816 15530.883)",
    fill: "#fcfcfc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprove);
export default __webpack_public_path__ + "static/media/Approve.b3d107e2d778f9bb7bc4a118d5bb086a.svg";
export { ForwardRef as ReactComponent };